const rankings = [
  {
    rank: 1,
    medal: 'gold',
    title: '流浪地球3',
    subtitle: '国产科幻里程碑续作',
    tag: '科幻 / 冒险',
    heat: '本周播放量第一',
    change: 'up',
    changeText: '新上榜',
  },
  {
    rank: 2,
    medal: 'silver',
    title: '封神第二部：战火西岐',
    subtitle: '史诗神话巨制',
    tag: '奇幻 / 史诗',
    heat: '口碑持续走高',
    change: 'up',
    changeText: '↑3位',
  },
  {
    rank: 3,
    medal: 'bronze',
    title: '奥本海默',
    subtitle: '诺兰导演传记力作',
    tag: '传记 / 历史',
    heat: '经典长尾效应',
    change: 'down',
    changeText: '↓1位',
  },
  {
    rank: 4,
    title: '沙丘2',
    subtitle: '维伦纽瓦科幻美学巅峰',
    tag: '科幻 / 冒险',
    heat: '持续热播中',
    change: 'up',
    changeText: '↑2位',
  },
  {
    rank: 5,
    title: '长安三万里',
    subtitle: '追光动画国风巨献',
    tag: '动画 / 历史',
    heat: '亲子观影首选',
    change: 'down',
    changeText: '↓1位',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
              热播排行
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              快看影视本周最受欢迎的五部电影
            </p>
          </div>

          <div className="space-y-3">
            {rankings.map((item) => {
              const medalColors: Record<string, string> = {
                gold: 'bg-yellow-50 border-yellow-200',
                silver: 'bg-background-200/50 border-background-300',
                bronze: 'bg-orange-50 border-orange-200',
              };
              const rankColors: Record<string, string> = {
                gold: 'text-yellow-600',
                silver: 'text-foreground-500',
                bronze: 'text-orange-600',
              };
              const medalIcons: Record<string, string> = {
                gold: 'ri-medal-fill',
                silver: 'ri-medal-fill',
                bronze: 'ri-medal-fill',
              };

              return (
                <div
                  key={item.rank}
                  className={`flex items-center gap-4 bg-background-50 rounded-xl p-5 border ${
                    item.medal
                      ? medalColors[item.medal]
                      : 'border-background-200/70'
                  }`}
                >
                  <div className={`w-10 h-10 flex items-center justify-center rounded-xl flex-shrink-0 ${
                    item.medal ? 'text-2xl' : 'bg-background-200/70'
                  } ${item.medal ? rankColors[item.medal] : 'text-foreground-600'}`}>
                    {item.medal ? (
                      <i className={medalIcons[item.medal]}></i>
                    ) : (
                      <span className="text-base font-bold">{item.rank}</span>
                    )}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-0.5">
                      <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950">
                        {item.title}
                      </h3>
                      <span className="text-xs text-foreground-400 whitespace-nowrap hidden sm:inline">
                        {item.subtitle}
                      </span>
                    </div>
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="px-1.5 py-0.5 rounded bg-primary-50 text-primary-700 text-xs font-medium">
                        {item.tag}
                      </span>
                      <span className="text-xs text-foreground-500">
                        <i className={`ri-fire-line mr-0.5 ${item.rank <= 3 ? 'text-primary-500' : ''}`}></i>
                        {item.heat}
                      </span>
                    </div>
                  </div>
                  <div className="flex-shrink-0 flex items-center gap-1">
                    {item.change === 'up' ? (
                      <i className="ri-arrow-up-line text-sm text-accent-500"></i>
                    ) : (
                      <i className="ri-arrow-down-line text-sm text-primary-500"></i>
                    )}
                    <span className="text-xs text-foreground-600 whitespace-nowrap">
                      {item.changeText}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}